import { render, staticRenderFns } from "./inicialPage.vue?vue&type=template&id=137a7273&scoped=true"
import script from "./inicialPage.vue?vue&type=script&lang=js"
export * from "./inicialPage.vue?vue&type=script&lang=js"
import style0 from "./inicialPage.vue?vue&type=style&index=0&id=137a7273&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137a7273",
  null
  
)

export default component.exports